module.exports = "https://coursera_assets.s3.amazonaws.com/images/9f4ad6b2d34e70c9a6b6a7f009705993.svg";